/**
 * 积木报表 URL token 工具（BUG-0023）
 *
 * 历史 appendToken 逻辑是"路径里已有 token 参数就不动"——tab 的路由 query
 * 里烘焙的是打开那一刻的 token，重新登录换新 token 后旧 token 永远甩不掉，
 * 恢复的报表 iframe 拿死 token 加载继续报错。
 *
 * 现语义：渲染时始终剥掉旧 token、拼上"当前"token，配合 iframe :key 绑
 * 当前 token，token 一变 iframe 自动重挂，报表 tab 重登后自愈。
 */

/**
 * 去掉 URL query 中的 token 参数（支持 hash、多个 token、token 在首/中/尾）
 * @param {string} path
 * @returns {string}
 */
export function stripTokenParam(path) {
  if (!path) return path
  if (path.indexOf('token=') === -1) return path

  const hashIndex = path.indexOf('#')
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : ''
  let base = hashIndex >= 0 ? path.slice(0, hashIndex) : path

  base = base
    .replace(/[?&]token=[^&]*/g, (match) => (match.startsWith('?') ? '?' : ''))
    .replace(/\?&/, '?')
    .replace(/\?$/, '')

  return base + hash
}

/**
 * 剥掉旧 token 后拼上当前 token（token 为空时原样返回剥完的路径）
 * @param {string} path
 * @param {string} token
 * @returns {string}
 */
export function appendCurrentToken(path, token) {
  const base = stripTokenParam(path)
  if (!base || !token) return base
  const connector = base.includes('?') ? '&' : '?'
  return `${base}${connector}token=${encodeURIComponent(token)}`
}
